import { isAuthRefreshBypassUrl } from "@/lib/api";

export type ApiClient401Recovery = {
  url: string;
  /** True when this request was already retried after a refresh attempt. */
  retried: boolean;
  refreshSession: () => Promise<void>;
  retryRequest: () => Promise<unknown>;
  onAuthFailure: () => void;
};

/**
 * Shared 401 recovery for ApiClient (lib/api/client.ts).
 *
 * Must attempt session refresh before hard-redirecting to /login — otherwise
 * concurrent callers on the cookie-based client race the Bearer client and
 * force a full-page logout while refresh would have succeeded
 * (APICLIENT-401-NO-REFRESH-1).
 */
export async function handleApiClient401(
  params: ApiClient401Recovery,
): Promise<unknown> {
  if (params.retried || isAuthRefreshBypassUrl(params.url)) {
    params.onAuthFailure();
    return Promise.reject(new Error("AUTH_FAILURE"));
  }
  try {
    await params.refreshSession();
    return await params.retryRequest();
  } catch (err) {
    params.onAuthFailure();
    return Promise.reject(err);
  }
}
